// §11/D68/D88 — Ergebnis-Download. Die presigned-GET-URL trägt server-seitig (D88)
// `Content-Disposition: attachment; filename="…"` → ein SYNCHRONER Anchor-Klick SPEICHERT die
// Datei, auch cross-origin OHNE R2-CORS. Synchron (kein await) heißt: der Klick bleibt im
// User-Gesten-Kontext → kein Popup-Blocker. (Der alte fetch→blob-Pfad scheiterte cross-origin an
// fehlendem R2-CORS und fiel auf ein NACH `await` geöffnetes — und damit oft blockiertes —
// window.open zurück; beim endungslosen, als octet-stream abgelegten Roh-Video kam so kein
// brauchbarer Download zustande.)
export function downloadResult(url: string, filename: string): void {
  const a = document.createElement("a");
  a.href = url;
  // `download` greift same-origin; cross-origin wird das Attribut ignoriert — dort erzwingt der
  // server-seitige Content-Disposition (D88) den Save samt Dateiname.
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/** Stabiler, sicherer Dateiname aus Asset-kind + id (ohne Pfad/Query). */
export function resultFilename(kind: string, id: string, ext = "png"): string {
  const stem = `${kind}-${id}`.replace(/[^a-zA-Z0-9._-]/g, "_").slice(0, 64);
  return `${stem}.${ext}`;
}
